export default "__VITE_ASSET__GgWqSzaT__"